import '@sass/fonts.scss';

import Vue from 'vue';
import {bootstrapApp as registerAnalytics} from '@client/util/analytics';
import vuetify from '@client/plugins/vuetify';
import '@client/bootstrap';
import '@client/globalComponents';
import '@client/plugins';
import router from '@client/router';
import {initialize as initializeInterceptors} from '@client/interceptors';
import store from '@client/store';
import eventServiceProvider from '@client/events/provider';
import {init as initAuth} from '@simpleinvest/front-end-auth';
import {init as initLogger} from '@simpleinvest/front-end-logger';

initializeInterceptors();
initAuth({
  env: process.env.VUE_APP_ENV,
  region: process.env.VUE_APP_REGION,
  userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
  userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
});
initLogger({
  env: process.env.VUE_APP_ENV,
  release: `client-dashboard-${process.env.PACKAGE_VERSION}`,
  sentryDsn: process.env.VUE_APP_SENTRY_DSN,
});
eventServiceProvider.register();

new Vue({
  name: 'ClientApp',
  store,
  components: {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    App: () => import('@client/components/App.vue'),
  },
  vuetify,
  router,
  beforeCreate(): void {
    registerAnalytics();
  },
}).$mount('#app');

Vue.config.productionTip = false;
